<template>
    <svg version="1.1"
         id="Layer_1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"
         xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
         xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
         xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:svg="http://www.w3.org/2000/svg"
         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 32 32"
         :style="`fill: ${iconColor};`" xml:space="preserve"
         :width="width"
         :height="height">
    <g transform="translate(0,-1020.3622)">
        <path d="M16,1031.1c-3,0-5.3,2.3-5.3,5.3s2.4,5.3,5.3,5.3s5.3-2.3,5.3-5.3S19,1031.1,16,1031.1z M16,1032.1c2.4,0,4.3,1.9,4.3,4.3
            c0,2.3-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3C11.7,1034,13.6,1032.1,16,1032.1z"/>
        <path d="M21,1036.4l-0.7,0.7l2.5,2.4l0.7-0.7L21,1036.4L21,1036.4z"/>
        <path d="M21.6,1041.2l-0.7,0.7l1.9,1.9l0.7-0.7L21.6,1041.2z"/>
        <path d="M20.5,1045.4l-0.7,0.7l1.9,1.9l0.7-0.7L20.5,1045.4z"/>
        <path d="M19.4,1048.6l-0.7,0.7l1.9,1.9l0.7-0.7L19.4,1048.6z"/>
        <path d="M15.7,1028.4c-2.9,0.1-5.7,1.8-7,4.6c-1.7,3.7-0.4,8.1,3.1,10.2c3.5,2.1,8,1.3,10.5-1.9c2.5-3.2,2.1-7.8-0.9-10.6
            c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l0,0c2.6,2.4,2.9,6.4,0.7,9.3c-2.1,2.8-6.1,3.5-9.1,1.7c-3-1.8-4.2-5.6-2.7-8.8
            c1.5-3.2,5.2-4.8,8.6-3.6c0.3,0.1,0.5,0,0.6-0.3c0.1-0.3,0-0.5-0.3-0.6l0,0C17.6,1028.5,16.6,1028.3,15.7,1028.4L15.7,1028.4z"/>
        <path d="M17,1025.8c-4-0.3-7.9,1.5-10.1,5c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1l0,0c2.6-4.3,8-5.7,12.5-3.6
            s6.5,7.5,4.7,12.1c-1.8,4.7-7,7.1-11.7,5.6c-4.8-1.4-7.7-6.3-6.6-11.1c0.1-0.3-0.1-0.5-0.4-0.6c-0.3-0.1-0.5,0.1-0.6,0.4
            c-1.1,5.4,2.1,10.7,7.4,12.3c5.3,1.6,10.9-1.2,13-6.3s-0.2-11-5.1-13.4C19.5,1026.2,18.2,1025.9,17,1025.8L17,1025.8z"/>
        <path d="M15.5,1023.1c-5,0.2-9.6,3.2-11.8,8c-2.8,6.4-0.1,13.8,6.1,17.1c6.2,3.2,13.9,1.1,17.5-4.9s2-13.7-3.6-17.8
            c-0.2-0.2-0.5-0.1-0.7,0.1c-0.2,0.2-0.1,0.5,0.1,0.7l0,0c5.2,3.7,6.7,10.9,3.4,16.4c-3.3,5.5-10.4,7.5-16.1,4.5s-8.2-9.8-5.6-15.8
            s9.3-8.8,15.4-6.7c0.3,0.1,0.5,0,0.6-0.3c0.1-0.3,0-0.5-0.3-0.6C18.8,1023.2,17.1,1023,15.5,1023.1z"/>
        <path d="M16.8,1020.4c-6-0.2-11.9,2.9-14.9,8.5c-0.1,0.2,0,0.5,0.2,0.7c0.2,0.2,0.5,0,0.7-0.2l0,0c3.7-7,12.3-9.9,19.5-6.6
            c7.3,3.3,10.6,11.6,7.7,18.9c-2.9,7.3-11,11.2-18.6,8.7c-7.6-2.4-11.9-10.3-9.8-18c0.1-0.3-0.1-0.5-0.4-0.6
            c-0.3-0.1-0.5,0.1-0.6,0.4l0,0c-2.1,8.2,2.5,16.6,10.5,19.3c8.1,2.7,16.8-1.5,19.9-9.4s-0.5-16.8-8.2-20.3
            C20.7,1021,18.7,1020.5,16.8,1020.4L16.8,1020.4z"/>
        <path d="M2.1,1030.8c0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5S2.1,1030.4,2.1,1030.8z"/>
        <path d="M22.4,1025c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5C22.2,1024.5,22.4,1024.7,22.4,1025z"/>
        <path d="M7,1032.7c0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5C6.8,1032.1,7,1032.4,7,1032.7z"/>
        <path d="M20.4,1030c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5l0,0C20.2,1029.5,20.4,1029.7,20.4,1030
            L20.4,1030z"/>
    </g>
    </svg>
</template>

<script>
    export default {
        name: "TrackBrandsIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>
